import {dataFetcher} from "../../services/dataGuetter/dataFetcher";

export async function getAllVues(idCentre:number|null):Promise<VuePlanning[]>{
    let url = `vue_plannings`;
    if(idCentre){
        url = `vue_plannings?Centre=${idCentre}`
    }
    const res:any = await dataFetcher(url, {method:'get'})
    return res["hydra:member"];
}